import { UPDATE_PAX_SUCCESS, UPDATE_PAX_FAIL } from './types';
import { SLACK_WEBHOOKS  } from '../config';
import axios from 'axios';
import { history } from '../components/app';
import { SlackWebhook } from './utils';
import _orderBy from 'lodash/orderBy';
import _filter from 'lodash/filter';
import _unionBy from 'lodash/unionBy';
import { checkLockout } from '../helpers/utils';


/**
 * Update Lead Passenger details via Busabout API
 *
 * @param {object} bookingGroup - bookingGroup payload
 * @param {object} form - redux form object
 */
export function UpdateLeadPassenger(bookingGroup, form){

  if(bookingGroup.trips.length === 0) return;

  const leadPax = _filter(bookingGroup.passengers, (o) => { return o.email; })[0];

  //check if lockout
  let phoneNumber;
  if(checkLockout(bookingGroup)){
    phoneNumber = form['PassengerDetails'].values.hasOwnProperty('phoneLockout') ? form['PassengerDetails'].values.phoneLockout : null;
  }else{
    phoneNumber = form['PassengerDetails'].values.hasOwnProperty('phone') ? form['PassengerDetails'].values.phone : null;
  }

  //Save lead passenger form details values with pax_guid and age_category
  const leadPaxMod = [{
     "passenger_identifier":leadPax.passenger_identifier,
     "age_category": leadPax.age_category,
     "first_name": form['PassengerDetails'].values.firstName,
     "family_name": form['PassengerDetails'].values.surname,
     "gender": form['PassengerDetails'].values.hasOwnProperty('sex') ? form['PassengerDetails'].values.sex : null,
     "date_of_birth": form['PassengerDetails'].values.dob.split("/").reverse().join("-"),
     "email": form['PassengerDetails'].values.email,
     "nationality": form['PassengerDetails'].values.nationality,
     "state": form['PassengerDetails'].values.hasOwnProperty('state') ? form['PassengerDetails'].values.state : null,
     "contact_telephone_country": form['PassengerDetails'].values.hasOwnProperty('phonePrefix') ? form['PassengerDetails'].values.phonePrefix : null,
     "contact_telephone_number": phoneNumber,
     "emergency_name": null,
     "emergency_telephone_country": null,
     "emergency_telephone_number":  null
  }];

  const leadPaxPayload = { "passengers": leadPaxMod };

  return leadPaxPayload;
}


/**
 * Update Passenger details via Busabout API
 *
 * @param {object} bookingGroup - bookingGroup payload
 * @param {object} form - redux form object
 */
 export function UpdatePassengers(bookingGroup, form){

    if(bookingGroup.trips.length === 0) return;

   //Order bookingGroup clients array by lead pax then secondary passengers
   const leadPax = _filter(bookingGroup.passengers, (o) => { return o.email; })[0];

   const secondaryPax = _orderBy(_filter(bookingGroup.passengers, (o) => { return !o.email; } ),['first_name'], ['asc']);



   //Save lead passenger form details values with pax_guid, age_category and emergency details
   const leadPaxMod = [{
      "passenger_identifier":leadPax.passenger_identifier,
      "age_category": leadPax.age_category,
      "first_name": leadPax.first_name,
			"family_name": leadPax.family_name,
			"gender": leadPax.gender,
      "date_of_birth": leadPax.date_of_birth,
			"email": leadPax.email,
			"iso_nationality": leadPax.nationality,
			"iso_nationality_sate": leadPax.state,
			"telephone_country_code": leadPax.contact_telephone_country,
			"telephone_number":  leadPax.contact_telephone_number,
      "emergency_contact": form['EmergencyPassenger'].values.firstName + " " + form['EmergencyPassenger'].values.surname,
      "emergency_country_Code":form['EmergencyPassenger'].values.emergencyPrefix,
      "emergency_number": form['EmergencyPassenger'].values.emergency
   }];


  //Save secondary passenger(s) form details with pax_guid, age_category and emergency details
  let secondaryPaxMod = [];
  for(let i = 0; i < secondaryPax.length; i++){
     secondaryPaxMod.push({
       "passenger_identifier": secondaryPax[i].passenger_identifier,
       "age_category": secondaryPax[0].age_category,
       "first_name": form['PassengerItem' + i].values.firstName,
       "family_name": form['PassengerItem' + i].values.surname,
       "gender": form['PassengerItem' + i].values.hasOwnProperty('sex') ? form['PassengerItem' + i].values.sex : null,
       "date_of_birth": form['PassengerItem' + i].values.dob.split("/").reverse().join("-"),
       "email": null,
       "iso_nationality": null,
       "iso_nationality_sate": null,
       "telephone_country_code": null,
       "telephone_number": null,
       "emergency_contact": form['EmergencyPassenger'].values.firstName + " " + form['EmergencyPassenger'].values.surname,
       "emergency_country_Code": form['EmergencyPassenger'].values.emergencyPrefix,
       "emergency_number": form['EmergencyPassenger'].values.emergency
     });
  }


  //Merge lead and secondary passenger(s)
  const mergedPaxPayload = { "passengers": _unionBy(leadPaxMod, secondaryPaxMod) };


  const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingGroup.group_booking_id}?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${bookingGroup.group_booking_id}`;

   const config = {
     headers:{
        'Content-Type': 'text/plain'
     },
     withCredentials: true
   };

   return (dispatch) => {
     axios.put(bookingURL, mergedPaxPayload, config)
     .then((response) => {
        if(response.data){
          dispatch({type:UPDATE_PAX_SUCCESS, payload:true});
        }
     })
     .catch((err)=>{
       console.error(err);
       dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (PUT) - ' + bookingURL + " " + err}));
       history.push('/500');
       dispatch({type:UPDATE_PAX_FAIL, payload:false});
     })
   }

}



// WEBPACK FOOTER //
// ./src/actions/passenger.js